module.exports = __webpack_public_path__ + "img/seguimiento-documentos-referido.aa43981a.svg";